import firebase from 'firebase'
import 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyA3D38GnrhfPjZzEQwfDb5pnnQB956sIbg",
  authDomain: "sportraxs-next.firebaseapp.com",
  databaseURL: "https://sportraxs-next.firebaseio.com",
  projectId: "sportraxs-next",
  storageBucket: "sportraxs-next.appspot.com",
  messagingSenderId: "247607002343",
  appId: "1:247607002343:web:0aa184844677f2ce978e42"
}

try {
  firebase.initializeApp(firebaseConfig);
} catch (err) {
  if (!/already exists/.test(err.message)) {
    console.error('Firebase initialization error', err.stack)
  }
}

const fire = firebase
export default fire



// WEBPACK FOOTER //
// ./src/utils/fire-config.js